// extracted by mini-css-extract-plugin
export default {"globalLoader":"GlobalLoader_globalLoader__Z6E6Q"};